export class ArticleClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/articles`;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async list(params) {
    const url = `${this.baseURL}`;

    const response = await this.httpClient.request("get", url, {
      params
    });

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async postRequest(id, params) {
    const url = `${this.baseURL}/${id}/request`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async postPublish(id, params) {
    const url = `${this.baseURL}/${id}/publish`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async put(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async getPin(pinType) {
    const url = `${this.baseURL}/pin/${pinType}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async putPin(pinType, params) {
    const url = `${this.baseURL}/pin/${pinType}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }
}
